import React, { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import {  orderRefundedAction } from '../../../redux/actions/orderActions'
import { uploadToCloudinary } from '../../../utils/uploadToCloudinary'
import store from '../../../store'

const RefundedForm = ({ order }) => {




    const dispatch = useDispatch()




    const [refund_image_proof_url, setRefund_image_proof_url] = useState('')
    const [refund_image_proof_url_preview, setRefund_image_proof_url_preview] = useState('')




    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (setImage, setPreview) => (e) => {
        e.preventDefault();

        const file = e.dataTransfer.files[0];

        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }
    };

    const handleFileChange = (setImage, setPreview) => (e) => {
        const file = e.target.files[0];

        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }
    };


    const displayID = String((order?.id)).padStart(6, '0');



    const handleSubmit =async (e) => {
        e.preventDefault();



        if (!refund_image_proof_url) {
            toast.error("Please fill in all required fields");
            return;
        }



          try {
            // ✅ START (add this)
            store.dispatch({ type: "UPLOAD_START" });

            // 1️⃣ Upload image
            const RefundProofURL = await uploadToCloudinary(
                refund_image_proof_url,
                "orders",
                1, // current
                1  // total
            );

            

            // 2️⃣ Send to backend
            const data = {
                refund_image_proof_url:RefundProofURL,
                order_id: order.id,
            };


        dispatch(orderRefundedAction(data))



            // ✅ END (add this)
            store.dispatch({ type: "UPLOAD_END" });

        } catch (err) {
            store.dispatch({ type: "UPLOAD_RESET" });

            toast.error("Image upload failed. Please Check your Internet Connection and then try again.");
        }





    }

    const handleReset = () => {
        setRefund_image_proof_url('')
        setRefund_image_proof_url_preview('')
    }

    return (
        <Fragment>
            <form action="" className="w-full max-w-2xl bg-white p-8 rounded-2xl shadow-xl shadow-zinc-100/50 border border-zinc-100 flex flex-col gap-6" onSubmit={handleSubmit}>
                
                {/* Info Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="bg-blue-50/50 p-4 rounded-xl border border-blue-100">
                        <span className='text-xs font-bold text-blue-600 uppercase tracking-wider'>Order ID</span>
                        <p className='text-lg font-bold text-blue-900 mt-1'>{displayID}</p>
                    </div>
                    <div className="bg-emerald-50/50 p-4 rounded-xl border border-emerald-100">
                        <span className='text-xs font-bold text-emerald-600 uppercase tracking-wider'>Order Number</span>
                        <p className='text-lg font-bold text-emerald-900 mt-1'>{order?.order_number}</p>
                    </div>
                </div>

                {/* Upload Section */}
                <div className="flex flex-col w-full">
                    <label className='text-sm font-bold text-zinc-700 mb-2'>Refund Proof <span className='text-red-500'>*</span></label>
                    
                    <div className="flex flex-col sm:flex-row gap-4 items-start">
                        {/* Preview */}
                        {refund_image_proof_url_preview && (
                            <div className="w-full sm:w-40 h-40 flex-shrink-0 bg-zinc-50 border border-zinc-200 rounded-xl overflow-hidden flex-center p-2">
                                <img
                                    src={refund_image_proof_url_preview}
                                    alt="Preview"
                                    className="w-full h-full object-contain rounded-lg"
                                />
                            </div>
                        )}

                        {/* Upload Area */}
                        <div
                            className={`flex-1 w-full border-2 border-dashed border-zinc-200 rounded-xl hover:border-indigo-500 hover:bg-indigo-50/10 transition-all cursor-pointer flex flex-col items-center justify-center p-6 min-h-[160px] group
                                ${refund_image_proof_url_preview ? "" : "w-full"}`}
                            onDrop={handleDrop(
                                setRefund_image_proof_url,
                                setRefund_image_proof_url_preview
                            )}
                            onDragOver={handleDragOver}
                            onClick={() => document.getElementById("refundproofInput").click()}
                        >
                            <input
                                id="refundproofInput"
                                type="file"
                                accept="image/png, image/jpeg"
                                onChange={handleFileChange(setRefund_image_proof_url, setRefund_image_proof_url_preview)}
                                className="hidden"
                            />
                            
                            <div className="w-12 h-12 bg-zinc-100 rounded-full flex-center text-zinc-500 text-2xl mb-3 group-hover:bg-indigo-100 group-hover:text-indigo-600 transition-colors">
                                <i className="fa-regular fa-image"></i>
                            </div>
                            
                            <p className="text-sm text-zinc-600 text-center leading-relaxed">
                                Drop your image here, or{" "}
                                <span className='text-indigo-600 font-semibold'>click to upload</span>
                            </p>
                            <p className="text-xs text-zinc-400 mt-1">PNG or JPG only</p>
                        </div>
                    </div>
                </div>

                {/* Buttons */}
                <div className="flex justify-end items-center gap-3 mt-4">
                    <button 
                        className="text-zinc-600 font-semibold py-3 px-6 rounded-xl border border-zinc-200 hover:bg-zinc-50 transition-all active:scale-[0.98]" 
                        onClick={handleReset} 
                        type='button'
                    >
                        Reset
                    </button>
                    <button 
                        className="bg-gradient-to-r from-indigo-600 to-indigo-700 text-white font-semibold py-3 px-8 rounded-xl hover:shadow-lg hover:shadow-indigo-100 transition-all active:scale-[0.98]" 
                        type='submit'
                    >
                        Submit Refund Proof
                    </button>
                </div>

            </form>
        </Fragment>
    )
}

export default RefundedForm